export default function getUrl() {
  const url = process.env.REACT_APP_API_URL;
  if (!url) {
    console.warn("⚠️ REACT_APP_API_URL is not set in the environment.");
  }
  return url || "";
}
